<template>
  <AppBar title="Repositories" />
  <div v-if="isPending" class="update">Loading...</div>
  <div v-else-if="isError">An error has occurred: {{ error }}</div>
  <div v-else-if="combined?.length">
    <v-list lines="two">
      <template v-for="(b, index) in combined" :key="b.id">
        <v-list-item
          v-if="b.owner && b.owner.login && b.name && b.has_issues"
          :subtitle="b.description || ''"
          :title="b.full_name || ''"
        >
          <template #prepend>
            <v-list-item-action start>
              <v-checkbox-btn
                :model-value="b.active"
                @change="toggle(index)"
              ></v-checkbox-btn>
            </v-list-item-action>
          </template>
        </v-list-item>
      </template>
    </v-list>
    <div v-if="isFetching" class="update">Background Updating...</div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import {
  addActiveRepository,
  currentAccount,
  currentAccounts,
  removeActiveRepository,
} from "../../authenticationTokens";
import { useRepoSearch } from "../../gen/forgejo-vue";

const server = computed(() => currentAccount.value?.server ?? "");

const uid = currentAccount.value?.uid ?? 0;

const { isPending, isError, isFetching, data, error } = useRepoSearch({
  uid,
  priority_owner_id: uid,
  mode: "source",
  archived: false,
});

const combined = computed(() => {
  const current = currentAccounts.value.find((r) => r.server === server.value);
  const activeRepoNames = new Set(
    (current?.repositories ?? []).map((r) => r.owner + "/" + r.repository),
  );
  return data.value?.data.data?.map((v) => {
    const active = activeRepoNames.has(v.full_name ?? "");
    return { ...v, active };
  });
});

function toggle(index: number) {
  const item = combined.value?.[index];
  if (item) {
    if (item.active) {
      removeActiveRepository(server.value, item.full_name ?? "");
    } else {
      addActiveRepository(server.value, item.full_name ?? "");
    }
  }
}
</script>
